import { Injectable, signal } from '@angular/core';
import { IScreenTypeStore, ScreenType } from './screen.types';

@Injectable({
  providedIn: 'root',
})
export class ScreenTypeStore implements IScreenTypeStore {
  private screenType = signal<ScreenType>('desktop');

  constructor() {
    let resizeObserver = new ResizeObserver(() => {
      const type = window.innerWidth > 915 ? 'desktop' : 'mobile';
      if (type !== this.screenType()) {
        this.screenType.set(type);
      }
    });

    const body = document.getElementsByTagName('body');
    resizeObserver.observe(body[0]);
  }

  getScreenType() {
    return this.screenType.asReadonly();
  }
}
